import {IImomoResponse} from './api.types';
import {ICmsContent} from '../hydromet/cms/cms.controller';

export interface ICmsApi {
	getCmsContent(name: string):ng.IPromise<ICmsContent[]>;
	saveCmsContent(name: string, content: ICmsContent[]):ng.IPromise<void>;
}

export default class CmsApi implements ICmsApi {
	static $inject = ['$http', 'backendUrl'];

	private cmsEndpoint:string;

	constructor (
		private $http:ng.IHttpService,
		private backendUrl:string
	) {
		this.cmsEndpoint = `${this.backendUrl}/content`;
	}

	getCmsContent(name: string): ng.IPromise<ICmsContent[]> {
		return this.$http<IImomoResponse<ICmsContent>>({
		  url: `${this.cmsEndpoint}/${name}`,
		  method: 'GET'
		}).then(httpData => {
		  return httpData.data.resources;
		});
	}

	saveCmsContent(name: string, content: ICmsContent[]): ng.IPromise<void> {
		return this.$http({
		  url: `${this.cmsEndpoint}/${name}`,
		  method: 'POST',
		  data: content
		}).then((httpData) => {
		  return httpData.data;
		}).catch((errData) => {
		  return errData;
		});
	}
}




/** WEBPACK FOOTER **
 ** ./app/api/cms-api.service.ts
 **/